import { render, staticRenderFns } from "./deploy.vue?vue&type=template&id=18c488c6&scoped=true&"
import script from "./deploy.vue?vue&type=script&lang=js&"
export * from "./deploy.vue?vue&type=script&lang=js&"
import style0 from "./deploy.vue?vue&type=style&index=0&id=18c488c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c488c6",
  null
  
)

export default component.exports